<template>
  <nx-auth-card
    :title="$t('message.login.changePassword.title')"
    v-on="$listeners"
  >
    <ds-text>
      {{ $t('message.login.changePassword.description') }} {{ passwordValidationMessage }}
    </ds-text>

    <nx-form
      ref="form"
      @form="form = $event"
      @submit.prevent="submit"
    >
      <nx-form-password
        v-model="newPassword"
        :label="$t('message.form.fields.newPassword')"
        :required-for-publish="true"
        :validation="validation"
        name="newPassword"
        required="true"
      />
      <v-btn
        :disabled="form.invalid || form.pristine"
        :loading="loading"
        block
        color="secondary"
        type="submit"
      >
        {{ $t('message.login.changePassword.changePassword') }}
      </v-btn>
    </nx-form>
  </nx-auth-card>
</template>

<script>
import { mapState } from 'vuex';
import NxForm from '@/modules/form/Form.vue';
import NxAuthCard from '@/modules/authentication/components/AuthCard.vue';
import NxFormPassword from '@/modules/form/components/FormPassword.vue';
import { LOGIN_PAGE_ID_LOGIN } from '@/modules/authentication/config/login-routes';
import AuthComponent from '@/modules/authentication/mixins/auth-component';
import PasswordValidationMessage from '@/modules/authentication/mixins/password-validation-message';

export default {
  name: 'NxAuthChangePassword',
  components: {
    NxFormPassword,
    NxAuthCard,
    NxForm,
  },
  mixins: [AuthComponent, PasswordValidationMessage],
  data() {
    return {
      newPassword: '',
      form: {},
    };
  },
  computed: {
    ...mapState('authentication', ['oldPassword', 'userNick']),
  },
  mounted() {
    if (!this.oldPassword
      || !this.userNick
    ) {
      this.redirectToLoginPage(LOGIN_PAGE_ID_LOGIN);
    }
  },
  methods: {
    async submit() {
      if (this.loading) {
        return;
      }

      if (this.newPassword === this.oldPassword) {
        await this.$nextTick();
        this.$refs.form.errors.add({
          field: 'newPassword',
          msg: this.$t('message.password.error.passwordMatchesOldOneError'),
        });
        return;
      }

      const result = await this.dispatch('authentication/CHANGE_PASSWORD', { newPassword: this.newPassword });
      if (!result.success) {
        this.$refs.form.errors.add({
          field: 'newPassword',
          msg: this.$t('message.login.invalidPassword'),
        });
      }
    },
  },
};
</script>
